import type { Country } from '@/features/destination';
import type { DepartureCity, DepartureCityType } from '@/features/departure-city';
import type { ApiCountryPosition, ApiDepartureCity } from './getSearchFormData.types';

function positionToCountry(pos: ApiCountryPosition): Country {
  const raw = pos.country ?? {};
  const visaDays = Number(raw.visaDays ?? 0);
  return {
    id: Number(raw.id),
    name: String(raw.name ?? ''),
    isPopular: !!pos.popular,
    position: pos.position ?? null,
    visaRequired: visaDays > 0 && !!raw.visaRequired,
    visaOnline: visaDays > 0 && !!raw.visaOnline,
    visaDays: visaDays > 0 ? visaDays : null,
    minPrice: null,
  };
}

export function adaptCountries(positions: ApiCountryPosition[]): Country[] {
  return positions
    .map(positionToCountry)
    .filter((country) => Number.isFinite(country.id) && country.name !== '');
}
export function adaptDepartureCities(raw: ApiDepartureCity[]): DepartureCity[] {
  return raw
    .map((city) => {
      const departureCity: DepartureCity = { id: Number(city.id), name: String(city.name ?? '') };
      if (city.type === 'capital' || city.type === 'region') {
        departureCity.type = city.type as DepartureCityType;
      }
      if (city.countriesWithDirectFlights) {
        departureCity.countriesWithDirectFlights = city.countriesWithDirectFlights;
      }
      return departureCity;
    })
    .filter((city) => Number.isFinite(city.id) && city.name !== '');
}
